var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('label',{class:[
    'radio-wrapper',
    _vm.isFocus ? 'radio-wrapper-checked' : '',
    _vm.disabled ? 'not-allowed' : '',
  ]},[_c('span',{class:['radio', _vm.isFocus ? 'radio-checked' : '']},[_c('span',{staticClass:"radio-inner"}),_c('input',{staticClass:"radio-input",attrs:{"type":"radio"},on:{"click":_vm.checked}})]),_vm._t("default")],2)
}
var staticRenderFns = []

export { render, staticRenderFns }